import { ButtonBorder } from 'src/components/Forms/Button';
import ModalC from 'src/components/Modal';
import { ISocialMedia } from 'src/interface/SocialMedia';
type Props = {
  dataShareButton?: ISocialMedia[];
  visibleModal: boolean;
  setVisibleModal: (e: any) => void;
  handleChangeGroupMobile: (e: any) => void;
  data: any;
};
const SelectModalMobile = (props: Props) => {
  const {
    handleChangeGroupMobile
  } = props;
  const onChangeGroup = (selectedKey: any) => {
    handleChangeGroupMobile(selectedKey);
  };
  return <ModalC open={props.visibleModal} hideButton={true} onCancel={() => props.setVisibleModal(false)}>
			<div style={{
      marginTop: '20px'
    }}>
				{props.data?.map((item: any) => <ButtonBorder text={item?.label} onClick={() => onChangeGroup(item)} key={item.value || item} style={{
        width: '95%',
        margin: '10px',
        border: '1px solid #4A4545',
        color: '#4A4545'
      }} />)}
			</div>
		</ModalC>;
};
export default SelectModalMobile;